export default "__VITE_ASSET__DOUiuCod__"